export enum StatsWidgetNumber {
  FirstStateWidget = 1,
  SecondStateWidget = 2,
  ThirdStateWidget = 3,
  ForthStateWidget = 4,
}
